import React from "react";
import { useTranslation } from 'react-i18next';
import "./skills.css";

const Skills = () => {
  const { t } = useTranslation();

  const skills = [
    {
      category: "Frontend",
      items: ["React", "JavaScript", "CSS3", "HTML5", "React Router"]
    },
    {
      category: "Backend",
      items: ["Node.js", "MongoDB", "Python", "Golang", "REST APIs", "PostgreSQL"]
    },
    {
      category: "DevOps & Cloud",
      items: ["Docker", "CI/CD", "AWS", "Azure", "Linux", "HAProxy", "Caddy", "Proxmox", "Ansible", "Terraform"]
    },
    {
      category: "Security & Network",
      items: ["Network Engineering", "Cybersecurity", "Firewalls", "VPN", "Penetration Testing"]
    },
    {
      category: "Tools & Other",
      items: ["Git", "GitHub", "VS Code", "Nginx", "vCenter"]
    }
  ];

  return (
    <section className="skills container section" id="skills">
      <h2 className="section__title">{t('skills_title') || 'Skills & Expertise'}</h2>
      
      <div className="skills__container">
        {skills.map((skillGroup, idx) => (
          <div key={idx} className="skills__group" data-aos="fade-up" data-aos-delay={idx * 100}>
            <h3 className="skills__category">{skillGroup.category}</h3>
            <div className="skills__list">
              {skillGroup.items.map((skill, i) => (
                <div key={i} className="skills__item">
                  <span className="skills__badge">{skill}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
